import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../shared/services/app-config.service';
import { CrazyCallConfigService } from '../shared/services/crazycall-config.service';
import { SingleProjectResponse } from '../shared/domain/configuration.model';
import { Observable } from 'rxjs/Observable';
import { ExistsResponse } from '../shared/domain/ExistsResponse';
import { ProjectResponse, ProjectWithStatsResponse } from './project';

@Injectable()
export class ProjectsService {
  constructor(
    private http: HttpClient,
    private crazyCallConfigService: CrazyCallConfigService,
    private appConfigService: AppConfigService
  ) {}

  get projectsUrl() {
    return `${this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL}${this.crazyCallConfigService.appId}/projects`;
  }

  get projectsWithStatsUrl() {
    return `${this.appConfigService.WEB_CALL_BACKEND_CONFIGURATOR_URL}${
      this.crazyCallConfigService.appId
    }/projects-stats`;
  }

  projectsWithStats(): Observable<ProjectWithStatsResponse[]> {
    return this.http.get<ProjectWithStatsResponse[]>(`${this.projectsUrl}/with-stats`);
  }

  allProjects(): Observable<ProjectResponse[]> {
    return this.http.get<ProjectResponse[]>(this.projectsUrl);
  }

  singleProject(projectId: number): Observable<SingleProjectResponse> {
    return this.http.get<SingleProjectResponse>(`${this.projectsUrl}/${projectId}`);
  }

  checkIfNameExists(name: string): Observable<ExistsResponse> {
    return this.http.get<ExistsResponse>(`${this.projectsUrl}/exists`, { params: { name } });
  }

  changeActivity(projectId: number, active: boolean): Observable<any> {
    return this.http.put(`${this.projectsUrl}/${projectId}/activity`, {}, { params: { active: active.toString() } });
  }

  removeProject(projectId: number) {
    return this.http.delete(`${this.projectsUrl}/${projectId}`);
  }
}
